module.exports = __webpack_public_path__ + "static/yellow_fast_fact-684360312d4c333729a2f597f39e5006.svg";